import request from '../utils/request.js'

export function getCgcc(query){
  return request({
    url: process.env.NODE_ENV === 'development' ?  '/sendMsg/cgcc' : process.env.MYURL + '/sendMsg/cgcc',
    method: 'get',
    params: query
  })
}
//获取验证码
export function getCheckCode(query){
  return request({
    url: process.env.NODE_ENV === 'development' ?  '/login/getMobileCode/'  : process.env.MYURL + '/login/getMobileCode/' ,
    method: 'get',
    params: query
  })
}


// WEBPACK FOOTER //
// ./src/api/elizabeth.js